import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";

interface WatchTripFailureProps {
  cn: (elementName: string) => string;
  onClose: () => void;
}

export const WatchTripFailure = ({
  cn,
  onClose,
}: WatchTripFailureProps): JSX.Element => {
  const { t } = useI18nContext();
  return (
    <div className={cn("failure-view")}>
      <p className={cn("subtitle")}>
        {t("flightShopPrediction.priceWatch.failureTitle")}
      </p>

      <p className={cn("description")}>
        {t("flightShopPrediction.priceWatch.failureMessage")}
      </p>

      <button
        className={clsx(cn("cta-button"), "cta-button")}
        type="submit"
        onClick={onClose}
      >
        {t("done")}
      </button>
    </div>
  );
};
